import { Input, Form } from "antd";
import React, { useRef, useState, useEffect } from "react";

const AutoGrowingInput = ({ name, minWidth = 200, maxWidth = 500 }) => {
  const spanRef = useRef(null);
  const [inputWidth, setInputWidth] = useState(minWidth);

  const handleChange = (e) => {
    const text = e.target.value || "";
    if (spanRef.current) {
      spanRef.current.textContent = text;
      const newWidth = Math.min(
        Math.max(spanRef.current.offsetWidth + 10, minWidth),
        maxWidth
      );
      setInputWidth(newWidth);
    }
  };

  useEffect(() => {
    // Trigger resize when mounted with initial value
    handleChange({ target: { value: "" } });
  }, []);

  return (
    <span style={{ position: "relative", display: "inline-block" }}>
      <Form.Item name={name} noStyle>
        <Input
          onChange={handleChange}
          style={{
            width: inputWidth,
            border: "none",
            borderBottom: "1px solid #000",
            padding: 0,
            background: "transparent",
          }}
        />
      </Form.Item>
      <span
        ref={spanRef}
        style={{
          position: "absolute",
          visibility: "hidden",
          whiteSpace: "pre",
          fontSize: 14,
          fontFamily: "inherit",
        }}
      />
    </span>
  );
};

export default AutoGrowingInput;
